import { SchedulesProvider, SchedulesService } from "@sportal/api/schedules";
import { SC_CODE } from "./appConfigService";
import { HttpService } from "@sportal/api";

export const makeScheduleService = (
  http: HttpService,
  baseUrl: string
): SchedulesService =>
  new SchedulesService(new SchedulesProvider(http, baseUrl, SC_CODE));
